import type { JSX } from 'react';

import { DocumentApi } from 'Api/Document/DocumentApi';
import { GovernanceApi } from 'Api/Governance/GovernanceApi';
import { Link } from 'Components/Buttons/Buttons';
import { GovernanceLibraryTable, GovernanceLibraryTableProps } from 'Components/Governance/GovernanceLibraryTable/GovernanceLibraryTable';
import { Text } from 'Components/Text/Text';
import { ICON_ADD_CREATE } from 'Config/Icons';
import { CREATE, GOVERNANCE } from 'Config/Paths';
import { GovernanceVersion, TextBasedGovernanceVersion } from 'Models/Governance';
import { OperationalControl } from 'Models/OperationalControls';

import styles from './Governance.module.css';

export interface GovernanceProps {
    governanceApi: GovernanceApi;
    documentApi: DocumentApi;
    governanceItems: GovernanceVersion[];
    displayGovernanceTextModal: (governance: TextBasedGovernanceVersion) => void;
    displayAssociatedControlsModal: (controls: OperationalControl[]) => void;
    controlIdentifier: string;
    openExternalUrl: (url: string) => void;
}

export const Governance = (props: GovernanceProps): JSX.Element => {
    const governanceListingTableProps: GovernanceLibraryTableProps = {
        documentApi: props.documentApi,
        governanceItems: props.governanceItems,
        governanceItemsAreManageable: true,
        displayGovernanceTextModal: props.displayGovernanceTextModal,
        displayAssociatedControlsModal: props.displayAssociatedControlsModal,
        controlIdentifier: props.controlIdentifier,
        openExternalUrl: props.openExternalUrl,
    };
    return (
        <>
            <div className={styles.header}>
                <Text color="blue" variant="Header2">
                    Policies, Standards, and Procedures
                </Text>
                <Link variant="primaryButton" to={`/${GOVERNANCE}/${CREATE}?controlId=${encodeURIComponent(props.controlIdentifier)}`} fontAwesomeImage={ICON_ADD_CREATE}>
                    Add New
                </Link>
            </div>
            <div className={styles.pageSection}>
                <GovernanceLibraryTable {...governanceListingTableProps} />
            </div>
        </>
    );
};
